import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import { getAccessToken } from '../api/axios';

let socket = null;

export function getSocket() {
  if (!socket) {
    socket = io('/', {
      auth: (callback) => callback({ token: getAccessToken() }),
    });
  }
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

export function useBoilerSocket(boilerId, onUpdate) {
  const callbackRef = useRef(onUpdate);
  callbackRef.current = onUpdate;

  useEffect(() => {
    if (!boilerId) return;
    const s = getSocket();
    s.emit('join_boiler', boilerId);
    const handler = (data) => {
      if (data.boilerId === boilerId) callbackRef.current(data);
    };
    const rejoin = () => {
      s.emit('join_boiler', boilerId);
    };
    s.on('boiler_update', handler);
    s.on('connect', rejoin);
    return () => {
      s.emit('leave_boiler', boilerId);
      s.off('boiler_update', handler);
      s.off('connect', rejoin);
    };
  }, [boilerId]);
}
